export const PEBInitialState = {
  counter:0,
  userDetail: {},
  filterAPIData: {},
  navigationTab: "/explore",
  filterApplyData: {},
  exploreFilterApplyData: [],
  callingExploreDisplayFiltersDataAPI:false,
  searchTextExplore: "",
  notificationData: {},
  disableData: false,
  deleteCardRefresh: {},
  filterData:{},
  recordData:null,
  supportingData:[],
  hasAccessToReport: true,
  tabName:'',
  respondentsCount:0,
  findingsReport: {
    isOpen: false,
    isFullWidth: false,
    analysisId: null,
    insight_list: [],
    supporting_data: [],
    selectedCard: "",
    analysisData: {
      name: "",
      description: "",
    },
    supportingDataMap: {},
    contentLength:0
  },
  tableParam: {
    pagination: {
      current: 1,
      total: 50,
    },
  },
  refreshAnalysisList: "",
  highlightCardData: {},
  analysisLockFlag: false,
  useCaseId:[],
  addAllClicked:false,
  exceedingCardsInReport:0,
  loadingDisplayCategoryQuesData:false,
  addMultipleCardsApiRunning:false,
  // totalCardsInReport:0,
  asyncApiResponse:false,
  minimizedOpenedReport:false,
  refreshReport: {
    refreshModal1Open: false,
    refreshModal2Open: false,
    refreshModal1Action: null, // "btn1" | "btn2" | null
    refreshModal2Action: null,
    oldAnalysisId:'',
    newAnalysisId:'',
    // YS this index gives index of current report on which disable has to be done
    
    disableReportIndex:-1,
    DisableReportIds: [], // stores multiple active row indices
    refreshAnalysisPage:false,
    filterExportLibraryCurrentPageData:[],
    maxReportCards:0,
    targetPopulationFilterData:[],
    checkCardLimitRunning:false,
    uniqueQuestionIdCount:0
  },
  pilot:{
    showWarningMsg:false
  }
};
